
////////////////////////////////////
// M072 premiumExample

function initPremiumExample(){
	
	if($(".premium-example").length > 0){
		
		$(".premium-example").each(function(){
			
			var $pe = $(this);

			if($pe.find(".premium-example__slider-element").length > 1){

				$pe.find(".premium-example__slider").slick({
					dots: true,
					arrows: true,
					infinite: true,
					draggable: false,
					slidesToShow: 1,
					centerMode: true,
					centerPadding: '0',
					variableWidth: false,
					adaptiveHeight: false,
					prevArrow: slickPrevArrowCode,
					nextArrow: slickNextArrowCode,
					responsive: [
						{
							breakpoint: _breakpointMedium,
							settings: {
								arrows: false,
								draggable: true,
							}
						}
					]
				});
			}
		});
	}
}

var _premiumExampleFootnoteHeight = 0;
var _premiumExampleContentHeight = 0;
function updatePremiumExample(){
	
	if($(".premium-example").length > 0){

		$(".premium-example").each(function(){
			
			_premiumExampleFootnoteHeight = 0;
			$(this).find(".premium-example__footnote").each(function(){
				$(this).css("height", "auto");
			});
			$(this).find(".premium-example__footnote").each(function(){
				if($(this).height() > _premiumExampleFootnoteHeight){
					_premiumExampleFootnoteHeight = $(this).height();
				}
			});
			
			_premiumExampleContentHeight = 0;
			$(this).find(".premium-example__content").each(function(){
				$(this).css("height", "auto");
			});
			$(this).find(".premium-example__content").each(function(){
				if($(this).height() > _premiumExampleContentHeight){
					_premiumExampleContentHeight = $(this).height();
				}
			});

			if(_premiumExampleFootnoteHeight > 0){

				$(this).find(".premium-example__footnote").each(function(){
					$(this).css("height", _premiumExampleFootnoteHeight + "px");
				});
				
				$(this).find(".slick-dots").css("bottom", (_premiumExampleFootnoteHeight+20) + "px");
			}

			if(_premiumExampleContentHeight > 0){

				$(this).find(".premium-example__content").each(function(){
					$(this).css("height", _premiumExampleContentHeight + "px");
				});
			}
		
		});
		
	}
}